module.exports = __webpack_public_path__ + "static/media/Calcium Carbonate.45b7557e.jpg";